import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M14.75,8a.76.76,0,0,1-.75.75H3.86l4.08,3.93a.76.76,0,0,1,0,1.07.75.75,0,0,1-.54.22.71.71,0,0,1-.52-.21L1.48,8.54A.76.76,0,0,1,1.25,8a.75.75,0,0,1,.23-.54L6.9,2.23a.75.75,0,0,1,1,1.08L3.86,7.25H14A.75.75,0,0,1,14.75,8Z';
const draw24px =
  'M20.75,12a.75.75,0,0,1-.75.75H5.86l4.08,3.94a.75.75,0,0,1,0,1.06.72.72,0,0,1-.54.23.73.73,0,0,1-.52-.21L3.48,12.54A.75.75,0,0,1,3.25,12a.76.76,0,0,1,.23-.54L8.9,6.24a.75.75,0,1,1,1,1.08L5.86,11.25H20A.76.76,0,0,1,20.75,12Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const ArrowLeftIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'arrowLeft'),
) as IconWithRender;

ArrowLeftIcon.displayName = 'ArrowLeftIcon';
ArrowLeftIcon.propTypes = Icon.propTypes;
ArrowLeftIcon.renderIcon = (props) => <ArrowLeftIcon {...props} />;
export default ArrowLeftIcon;
